<template>
    <div class="pages view">
        <EditMedia 
            v-if="currentPage === 'media'"
            :titel="'Media bestanden'"
            :zoek="'Zoek media bestanden'"
            :button="true"
        />
    </div>
</template>
<script>
import EditMedia from '../components/media/EditMedia.vue';
export default {
    inject:['data', 'status'],
    components:{
        EditMedia
    },
    data(){
        return{
            currentPage: "media"
        }
    },
    created(){
            if(this.$route.query.page == "projects"){
                sessionStorage.DevPage = "projects"
                this.currentPage = "projects"
            } else if(this.$route.query.page == "nieuws"){
                sessionStorage.DevPage = "nieuws"
                this.currentPage = "nieuws"
            }  else if(this.$route.query.page == "vacature"){
                sessionStorage.DevPage = "vacature"
                this.currentPage = "vacature"
            }  else if(this.$route.query.page == "openingsuren"){
                sessionStorage.DevPage = "openingsuren"
                this.currentPage = "openingsuren"
            }

    },  
    methods:{
        pageRouter(page){
            this.currentPage = page;
        }
    }
}
</script>